<template>
  <section id="faqs" class="px-4 bg-white lg:px-0">
    <div
      v-if="faqs.length"
      class="container px-4 md:px-10 lg:px-[60px] xl:px-[85px] xl:pt-28 xl:pb-20 py-12 md:py-[100px] bg-white"
    >
      <h4
        class="mb-[10px] md:mb-6 text-xl md:text-2xl lg:text-[28px] lg:leading-[32px] text-secondary-dark font-myriad-pro-condensed font-semibold text-center uppercase break-words px-4 pt-14 md:pt-6"
      >
        {{ $t("common.faq") }}
      </h4>

      <div
        v-for="(faq, faqIndex) in faqs"
        :key="faqIndex"
        class="xl:mb-10 mb-[30px]"
      >
        <div v-if="faq.published">
          <h2
            class="pr-3 xl:px-[30px] mb-8 text-lg md:text-xl font-myriad-pro font-bold text__heading"
            v-text="faq.title"
          />
          <div class="mt-10 space-y-2 md:space-y-3 md:mt-0">
            <!-- Support -->
            <AccordionList
              class="m-0 list-none bg-white xl:py-5 xl:px-[30px] p-5 rounded-m space-y-3"
            >
              <AccordionItem
                v-for="(item, index) in faq.items"
                :key="index"
                :active-index="index == 0"
                class="bg-[#F9F9F9] rounded-md"
              >
                <template slot="accordion-close-trigger">
                  <div
                    class="flex items-center justify-between w-full xl:py-5 xl:px-[30px] p-5"
                  >
                    <h3
                      class="flex-1 inline text-base font-bold tracking-wider md:text-lg font-myriad-pro"
                      v-text="item.question"
                    />
                    <div
                      class="inline p-1.5 lg:p-2 xl:p-2.5 ml-2 md:ml-8 xl:ml-6 text-black w-[36px] h-[36px] lg:w-10 lg:h-10 xl:w-11 xl:h-11"
                    >
                      <CloseIcon class="inline text-black" />
                    </div>
                  </div>
                </template>
                <template slot="accordion-trigger">
                  <div
                    class="flex items-center justify-between w-full xl:py-5 xl:px-[30px] p-5"
                  >
                    <h3
                      class="flex-1 inline text-base font-bold tracking-wider md:text-lg font-myriad-pro"
                      v-text="item.question"
                    />
                    <div
                      class="inline p-1.5 lg:p-2 xl:p-2.5 ml-2 md:ml-8 xl:ml-6 text-black w-[36px] h-[36px] lg:w-10 lg:h-10 xl:w-11 xl:h-11"
                    >
                      <PlusIcon class="inline text-black" />
                    </div>
                  </div>
                </template>
                <div slot="accordion-content" class="xl:px-[30px] px-5">
                  <div
                    class="pb-5 md:pt-4 xl:pt-3 xl:pr-[103px] md:pr-[77px] lg:pr-[293px] pr-[10px]"
                  >
                    <!-- eslint-disable-next-line -->
                    <div
                      class="text-base font-light font-myriad-pro md:text-lg"
                      v-html="item.answer"
                    ></div>
                  </div>
                </div>
              </AccordionItem>
            </AccordionList>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import PlusIcon from "@/assets/svg/heroicons/plus.svg?component";
import CloseIcon from "@/assets/svg/heroicons/x.svg?component";

const props = defineProps({
  productSlug: {
    type: String,
    required: true,
  },
});

const emit = defineEmits();

const faqs = ref([]);

onBeforeMount(() => {
  loadFaqs();
});

function isVisible(index) {
  return true;
}

async function loadFaqs() {
  try {
    const { data } = await useAPI(
      "api/front/product/" + props.productSlug + "/faqs"
    );
    // const data = FaqsJsonData.data
    faqs.value = data;
    if (faqs.value.length > 0) {
      emit("has-faq", true);
    } else {
      emit("has-faq", false);
    }
  } catch (error) {
    // console.error(`Error connecting '/api/front/faqs'`)
  }
}
</script>
